/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { ProjectDataModule } from './project-data.module';
export { ProjectDataComponent } from './project-data-component';